import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useAppSelector } from 'features/app/hooks';
import {
  previousCallIdSelector,
  selectPreviousCallBeingReportedId,
} from 'features/call/vrs-call-comments/store';
import theme from 'features/theme/theme';

export const VrsCallCommentsBugReportCallId = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'callId' });
  const previousCallId = useAppSelector(previousCallIdSelector);
  const reportedCallId = useAppSelector(selectPreviousCallBeingReportedId);

  return (
    <>
      <Typography variant='label' color={theme.palette.grey[100]}>
        {t('title')}
      </Typography>
      <Typography variant='body1' color={theme.palette.common.white}>
        {reportedCallId || previousCallId}
      </Typography>
    </>
  );
};
